// Not a client module on purpose: this is a plain class string, and a non-component export from a
// 'use client' file becomes a client reference under a React Server Components bundler.

/**
 * The 44px touch floor for a row of caller-supplied action controls, applied to the row's DIRECT
 * children only (Tailwind's `*:` variant), and only below `md`. A composite that renders its own
 * action row (a report frame wrapping a Print button and a Refresh button, a portal host) adds this
 * to that row so its controls follow the same rule as `PageActions`.
 *
 * Why direct children and not every descendant button: the control the caller put in the slot is
 * the thing that must be 44px. A `SearchInput` in the slot is one control (its wrapper grows); its
 * clear button, a `Switch`'s thumb or a `SegmentedControl` segment are parts of a control and must
 * not be resized by a selector that cannot tell them apart (#16194, the withdrawn `[&_button]` rule).
 */
export const PAGE_ACTION_FLOOR = 'max-md:*:min-h-11';

/**
 * The overflow menu's trigger at the same floor: a 44px square below `md`. Pass it as the
 * `triggerClassName` of the `ActionMenu` handed to `PageActions` as `menu` (the trigger is a child of
 * the menu's own container, so the slot floor above does not reach it).
 */
export const PAGE_ACTION_MENU_TRIGGER = 'max-md:h-11 max-md:w-11';
